import React from "react";


import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";


export const AttachFileIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue226'}</MuiIcon>
    );
}
